import React from 'react'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import Resx from '@/components/Resx'
import Name from '@/components/Name'
import StatusEnum from '@/components/StatusEnum'
import { RelatedReportSubmissionGroups } from '@/internal-app/pages/tickets/relatedReportSubmissionGroups'
import { FileAttachments } from '@/components/fileAttachments'
import context from '@/context'
import MyTicketComments from '@/internal-app/pages/tickets/comments/myTicketComments'
import { RetryWorkflowButton } from '@/internal-app/pages/tickets/retryWorkflowButton'
import { formatDate } from '@/utils/dateUtilities'
import { Link } from 'react-router-dom'
import Icon from '@/components/Icon'
import { RestartWorkflowButton } from '@/internal-app/pages/tickets/restartWorkflowButton'

export function TicketInfo (props) {
  const { ticket, related, workflowResumeHandler, workflowRestartHandler, restartedAsTicketId } = props // eslint-disable-line

  return (
    <React.Fragment>
      <InfoRow>
        <InfoLabel size='sm'><Resx name='Common.Name' /></InfoLabel>
        <InfoContent><Name data={{ name: ticket.name, latinName: ticket.latinName }} /></InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel size='sm'><Resx name='Common.Status' /></InfoLabel>
        <InfoContent>
          <StatusEnum enumName='TicketStatus' value={ticket.status} visualStatus={[0, 1, 2, 3, 3]} />
          {ticket.status === 4 && !related ? <RetryWorkflowButton ticketId={ticket.id} onResume={workflowResumeHandler} /> : null}
          {ticket.status !== 2 && ticket.status !== 3 && !related
            ? <RestartWorkflowButton ticketId={ticket.id} onRestart={workflowRestartHandler} />
            : null}
        </InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel size='sm'><Resx name='Common.Result' /></InfoLabel>
        <InfoContent><StatusEnum enumName='TicketResult' value={ticket.result} visualStatus={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]} /></InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel size='sm'><Resx name='Tickets.Type' /></InfoLabel>
        <InfoContent>{ticket.ticketType}</InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel size='sm'><Resx name='Common.CreationTime' /></InfoLabel>
        <InfoContent>{formatDate(ticket.creationTime)}</InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel size='sm'><Resx name='Tickets.Origin' /></InfoLabel>
        <InfoContent><Resx name={ticket.author ? 'Tickets.CreatedByUser' : 'Tickets.CreatedBySystem'} /></InfoContent>
      </InfoRow>
      {ticket.author &&
      <InfoRow>
        <InfoLabel size='sm'><Resx name='Common.Author' /></InfoLabel>
        <InfoContent>{ticket.author}</InfoContent>
      </InfoRow>
      }
      {!!ticket.parentId &&
      <InfoRow>
        <InfoLabel size='sm'><Resx name='Tickets.ParentTicket' /></InfoLabel>
        <InfoContent><Link to={`/tickets/${ticket.parentId}`}><span className='ticket-label'><Icon name='list-alt' /> {ticket.parentId}</span></Link></InfoContent>
      </InfoRow>
      }
      <RelatedReportSubmissionGroups relatedSubmissionGroups={ticket.relatedSubmissionGroups} />
      <InfoRow>
        <InfoLabel size='sm'><Resx name='Common.Description' /></InfoLabel>
        <InfoContent>
          <div className='cms__text'>
            <Name data={{ name: ticket.description, latinName: ticket.latinDescription }} />
          </div>
        </InfoContent>
      </InfoRow>
      <InfoRow>
        <InfoLabel size='sm'><Resx name='Tasks.Attachments' /></InfoLabel>
        <InfoContent>
          <FileAttachments
            readonly
            attachments={ticket.attachments || []}
            downloadAction={context.api.ticketService.download} />
        </InfoContent>
      </InfoRow>
      <MyTicketComments key={`ticketComments_${ticket.id}`} ticketId={ticket.id} title={related && 'Tasks.TicketComments'} />
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/tickets/ticketInfo.js